import { Roles, Subjects } from "settings/permissions";

export const REDIRECT_TO_COMPLIANCE_EVENT_DETAILS = "/security/event_details";
export const REDIRECT_TO_SECURITY_ACCOUNTS = "/security/security_overview";
export const REDIRECT_TO_SECURITY_DETAILS = "/security/security_details";

export const securityPages = {
  id: "Security",
  label: "Security",
  icon: "securityAnalyticsApp",
  items: [
    {
      label: "Audit Events",
      path: "/security/event_overview",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.SQL_Audit_Dashboard,
        role: Roles.Read,
      },
      topNavLinks: [
        {
          label: "Overview",
          path: "/security/event_overview",
          requireClientSelection: true,
        },
        {
          label: "Details",
          path: "/security/event_details",
          requireClientSelection: true,
        },
      ],
    },
    {
      label: "Server Logins",
      path: "/security/security_overview",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Security_Dashboard,
        role: Roles.Read,
      },
      topNavLinks: [
        {
          label: "Overview",
          path: "/security/security_overview",
          requireClientSelection: true,
        },
        {
          label: "Details",
          path: "/security/security_details",
          requireClientSelection: true,
        },
      ],
    },
  ],
};
